module.exports = __webpack_public_path__ + "img/header-weddingRingsRingSets.54b24fe.webp";